import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore'

import { sortByKey, sortByDateKey } from '../../util/sorting'
import { Divider } from '../styles/Containers'
import {
  CondensedTable,
  HeaderRow,
  HeaderButton,
  TemplateNameColumn,
  TemplateDateColumn,
  TemplateActionContainer,
  UnfoldMoreIconRight,
  EmptyText
} from '../styles/TableStyles'
import LetterTemplateRow from './LetterTemplateRow'

const SORT_KEYS = {
  name: sortByKey('name'),
  updatedAt: sortByDateKey('updatedAt')
}

function LetterTemplateTable({ letterTemplates, onEditLetterTemplate = () => {}, handleSelectTemplate = () => {} }) {
  const [sortBy, setSortBy] = useState('updatedAt')
  const [sortedTemplates, setSortedTemplates] = useState([])
  const [sortAscending, setSortAscending] = useState(true)

  function sort(key) {
    if (key === sortBy) {
      setSortedTemplates(prev => [...prev].reverse())
      setSortAscending(prev => !prev)
    } else {
      setSortBy(key)
      setSortAscending(true)
      setSortedTemplates(prev => [...prev].sort(SORT_KEYS[key]))
    }
  }

  useEffect(() => {
    if (letterTemplates && letterTemplates.length > 0) {
      const comparator = SORT_KEYS[sortBy]
      let next = [...letterTemplates].sort(comparator)
      if (!sortAscending) next = next.reverse()
      setSortedTemplates(next)
    } else {
      setSortedTemplates([])
    }
  }, [letterTemplates])

  return (
    <CondensedTable>
      <HeaderRow>
        <TemplateNameColumn>
          <HeaderButton variant="text" onClick={() => sort('name')} active={(sortBy === 'name').toString()}>
            Template Name <UnfoldMoreIcon />
          </HeaderButton>
        </TemplateNameColumn>
        <TemplateDateColumn>
          <HeaderButton variant="text" onClick={() => sort('updatedAt')} active={(sortBy === 'updatedAt').toString()}>
            Last Modified <UnfoldMoreIconRight />
          </HeaderButton>
        </TemplateDateColumn>
        <TemplateActionContainer />
      </HeaderRow>
      <Divider />
      {sortedTemplates && sortedTemplates.length > 0 ? (
        sortedTemplates.map(letterTemplate => (
          <React.Fragment key={letterTemplate.id}>
            <LetterTemplateRow
              letterTemplate={letterTemplate}
              onEditLetterTemplate={onEditLetterTemplate}
              handleSelectTemplate={handleSelectTemplate}
            />
            <Divider />
          </React.Fragment>
        ))
      ) : (
        <EmptyText>No letter templates available</EmptyText>
      )}
    </CondensedTable>
  )
}

LetterTemplateTable.propTypes = {
  letterTemplates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      updatedAt: PropTypes.instanceOf(Date).isRequired
    })
  ).isRequired,
  onEditLetterTemplate: PropTypes.func,
  handleSelectTemplate: PropTypes.func
}

export default LetterTemplateTable
